import React, { useState } from 'react'
import { Col, Row, Card, Container, Image } from 'react-bootstrap';

import TWNCover from '../../../../assets/img/portfolio/twn_cover.svg'
import SafehouseCover from '../../../../assets/img/portfolio/safehouse_cover.svg'
import CoDesignCover from '../../../../assets/img/portfolio/codesign_cover.svg'
import VirusAICover from '../../../../assets/img/portfolio/virus_ai_cover.svg'
import BittorrentCover from '../../../../assets/img/portfolio/bittorrent_cover.svg'
import WeParkCover from '../../../../assets/img/portfolio/wepark_cover.svg'

const ProjectCardDeck = () => {
    const TWNSummary = "An AI-powered news platform built to deliver unbiased, factual reporting. Each morning, the app gathered top headlines from major publications and used AI to rewrite them in a neutral tone, stripping out emotional language and political framing so readers could stay informed without the spin."
    const SafeHouseSummary = "A blockchain-based system for storing and verifying real estate ownership. Users could upload lease, deed, and ownership documents, verify their identity, and receive a digitally verified proof of ownership secured on a blockchain maintained by the backend application."
    const CoDesignSummary = "A lightweight alternative to GitHub, Jira, and Slack for coordinating technical projects. Users could collaboratively “storyboard” a project visually, then post individual sections to a built-in marketplace where freelancers could bid to complete the work."
    const VirusAISummary = "An exploration of generative AI applied to epidemiological simulation. A synthetic population was modeled in code, and a generative AI model was given an abstract “DNA” trait vector to evolve, learning through simulation which traits most increased spread within the model."
    const BitTorrentSummary = "A from-scratch clone of the BitTorrent protocol, built in C to make peer discovery and network programming as difficult as possible. The client successfully assembled a file from chunks sourced across a distributed swarm of peers."
    const WeParkSummary = "A peer-to-peer parking app born from a common frustration: unused residential parking passes near campus. The app let nearby residents list an open spot and set an hourly price, while drivers searched a live map for the closest available space."

    return (
        <section>
            <Container>
                <h2 className='text-center text-secondary'>PROJECTS</h2>
                <hr className='star-light mb-0' />
                <Row>
                    <ProjectCardCol title='True World News' cover={TWNCover} summary={TWNSummary} />
                    <ProjectCardCol title='SafeHouse Digital' cover={SafehouseCover} summary={SafeHouseSummary} />
                    <ProjectCardCol title='Co-Design' cover={CoDesignCover} summary={CoDesignSummary} />
                    <ProjectCardCol title='Virus AI' cover={VirusAICover} summary={VirusAISummary} />
                    <ProjectCardCol title='Bittorrent Clone' cover={BittorrentCover} summary={BitTorrentSummary} />
                    <ProjectCardCol title='WePark' cover={WeParkCover} summary={WeParkSummary} />
                </Row>
            </Container>
        </section>
    )
}

const ProjectCardCol = ({ title, cover, summary }) => {
    const [flipped, setFlipped] = useState(false)

    const innerStyle = {
        position: 'relative',
        width: '100%',
        height: '100%',
        transition: 'transform 0.6s ease-in-out',
        transformStyle: 'preserve-3d',
        transform: flipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
    }

    const sideStyle = {
        position: 'absolute',
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        fontSize: "1.1rem",
        border: 'none'
    };

    const frontStyle = {
        ...sideStyle,
        backgroundColor: "#ffffff",
    };

    const backStyle = {
        ...sideStyle,
        transform: "rotateY(180deg)",
    };

    return (
        <Col md={6} lg={4} className='py-1 d-flex justify-content-center'>
            <div
                className='flip-card'
                onMouseEnter={() => setFlipped(true)}
                onMouseLeave={() => setFlipped(false)}
                onClick={() => setFlipped((f) => !f)}
                role='button'
                tabIndex={0}
                aria-label={`${title} project card, tap or hover to see details`}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setFlipped((f) => !f) } }}
            >
                <div style={innerStyle}>
                    <Card style={frontStyle}>
                        <Card.Body className='p-0'>
                            <Image rounded src={cover} width='100%' height='100%' alt={`${title} cover art`} />
                        </Card.Body>
                    </Card>
                    <Card style={backStyle} className='bg-primary p-0'>
                        <Card.Body className='p-0'>
                            <h3 className='text-uppercase text-secondary text-center m-0 p-1'>{title}</h3>
                            <p className='text-secondary text-center p-1' style={{fontSize: '16px'}}>{summary}</p>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </Col>
    )
}

export default ProjectCardDeck;